import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { LocalStorageService } from '@app/core/local-storage.service';

@Injectable({ providedIn: 'root' })
export class HomeGuard  {

  constructor(
    private readonly router: Router,
    private readonly _localS: LocalStorageService
  ) { }
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean | UrlTree | Promise<boolean | UrlTree> | Observable<boolean | UrlTree> {

    const activeUser = this._localS.getAuthData();

    if (!activeUser?.accessToken) {
      this.router.navigate(['/auth']);
      return false;
    }

    return true;

  }
}
